import React from 'react';
import moment from 'moment';
import './BookingCard.css';

// Status → pill tone, matching the web bookings table's colours.
const STATUS_TONE = {
    pending: 'pending',
    confirmed: 'confirmed',
    active: 'confirmed',
    in_progress: 'confirmed',
    completed: 'completed',
    cancelled: 'cancelled',
    refunded: 'cancelled',
    'no show': 'muted',
    no_show: 'muted',
};

const customerName = (b) => b.user_id?.name || b.guest_name || 'Walk-in';

const avatarFallback = (name) =>
    `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=E3F0FC&color=4F97D8&size=96`;

// Total minutes across every service on the booking, e.g. "1h 00m" / "45m".
const totalDuration = (b) => {
    const minutes = (b.services || []).reduce((sum, s) => sum + (parseInt(s.duration, 10) || 0), 0);
    if (!minutes) return null;
    const h = Math.floor(minutes / 60);
    return h ? `${h}h ${String(minutes % 60).padStart(2, '0')}m` : `${minutes}m`;
};

/**
 * One booking as a tappable schedule row (time block, customer, services, room,
 * status) — the phone replacement for a bookings table row. Used by the
 * dashboard's recent bookings and the bookings list on small screens.
 */
const BookingCard = ({ booking: b, onClick }) => {
    const name = customerName(b);
    const services = (b.services || []).map((s) => s.service_id?.title).filter(Boolean).join(', ') || '—';
    const time = b.booking_time ? moment(b.booking_time, 'HH:mm').format('hh:mm A') : '—';
    const date = b.booking_date ? moment(b.booking_date).format('DD MMM') : '';
    const duration = totalDuration(b);
    const tone = STATUS_TONE[String(b.status || '').toLowerCase()] || 'muted';

    return (
        <button type="button" className="bk-card" onClick={() => onClick?.(b)}>
            <span className={`bk-card-time tone-${tone}`}>
                <strong>{time}</strong>
                <span>{date}</span>
            </span>
            <img
                className="bk-card-avatar"
                src={b.user_id?.picture || avatarFallback(name)}
                alt=""
                onError={(e) => { e.currentTarget.src = avatarFallback(name); }}
            />
            <span className="bk-card-body">
                <span className="bk-card-name">{name}</span>
                <span className="bk-card-services">{services}</span>
                <span className="bk-card-meta">
                    {b.room_id?.title && <span><i className="bi bi-geo-alt"></i>{b.room_id.title}</span>}
                    {duration && <span><i className="bi bi-clock"></i>{duration}</span>}
                    <span className={`bk-pill tone-${tone}`}>{b.status || 'N/A'}</span>
                </span>
            </span>
            <i className="bi bi-chevron-right bk-card-chevron"></i>
        </button>
    );
};

export default BookingCard;
